import { Component, OnInit, HostListener } from '@angular/core';
import {helpService} from '../../services/help.service';
import { ElementoBusqueda } from '../../models/help';
import { Router } from '@angular/router';
import { clean } from "diacritic";

@Component({
  selector: 'app-busqueda',
  templateUrl: './busqueda.component.html',
  styleUrls: ['./busqueda.component.css']
})
export class BusquedaComponent implements OnInit {


  public isLoading = false;
  public src: string;
  public data:ElementoBusqueda[] =[];
  public focusElement: number = -1;
  public itemlen: number = 0;
  public show = true;
  public errorBusqueda = false;
  public strBusqueda:string[];

  constructor(private apiRest: helpService, private _router: Router) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('buscado') && sessionStorage.getItem('buscado').length >0) {
    this.src =sessionStorage.getItem('buscado');
    this.search(this.src);
   }
}

  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    this.show = false;
    sessionStorage.setItem('buscado','');
  }

  search(value: string) {
    this.strBusqueda=value.split(' ');
    
    this.isLoading = false;
    if (value.length>1){
      this.isLoading = true;
      this.show = true;
      this.apiRest.BuscadorPublic(value)
      .subscribe(
        (resp: ElementoBusqueda[]) => {
          this.data = resp;
          this.isLoading = false;
          this.errorBusqueda=false;
          sessionStorage.setItem('buscado',value);
        },
        error => {
          this.data =[];
          this.isLoading = false;
          this.errorBusqueda=true;
      })
    }
  }

  onLocationFocus() {
    this.focusElement = 0;
  }
  onLocationBlur() {
    this.focusElement = -1;

  }

  onArrowUp() {
    if (this.focusElement > 0) {
      this.focusElement--;
    }
    return false;
  }

  onEnter(value: number) {
    event.preventDefault();
    this.show = false;
    if (value==0){
      if (this.src.length >1){
        this._router.navigate(['help/buscar',this.src]);
      }
      else {
        this.errorBusqueda = true;
        this.show=true;
      }
    }else{
      this._router.navigate(['help/respuesta',value]);
    }
  }


  onEsc() {
    this.show = false;
  }

  onArrowDown() {
    if (this.focusElement <= this.data.length-2) {
      this.focusElement++;
    }
  }

  removeDiacritics(text: string): string {
    return clean(text);
  }
}
